import NotificationSubscriptionRoute from './NotificationSubscriptionRoute'
import NotificationTriggerRoute from "./NotificationTriggerRoute";

const routes = [
    new NotificationSubscriptionRoute(),
    new NotificationTriggerRoute()
]

export default routes
